// extracted by mini-css-extract-plugin
module.exports = {"or":"styles_or__19ZIL","inputWrap":"styles_inputWrap__1Hxcg","input":"styles_input__r_pVR"};